/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Next_Result_Aria_LabelInputs */

const en_find_replace_next_result_aria_label = /** @type {(inputs: Find_Replace_Next_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next result`)
};

const fr_find_replace_next_result_aria_label = /** @type {(inputs: Find_Replace_Next_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultat suivant`)
};

const de_find_replace_next_result_aria_label = /** @type {(inputs: Find_Replace_Next_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächstes Ergebnis`)
};

const it_find_replace_next_result_aria_label = /** @type {(inputs: Find_Replace_Next_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultato successivo`)
};

const ru_find_replace_next_result_aria_label = /** @type {(inputs: Find_Replace_Next_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий результат`)
};

const es_find_replace_next_result_aria_label = /** @type {(inputs: Find_Replace_Next_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente resultado`)
};

const zh_cn2_find_replace_next_result_aria_label = /** @type {(inputs: Find_Replace_Next_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个结果`)
};

const ja_find_replace_next_result_aria_label = /** @type {(inputs: Find_Replace_Next_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の結果`)
};

const hi_find_replace_next_result_aria_label = /** @type {(inputs: Find_Replace_Next_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला परिणाम`)
};

const pt_pt2_find_replace_next_result_aria_label = /** @type {(inputs: Find_Replace_Next_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo resultado`)
};

/**
* | output |
* | --- |
* | "Next result" |
*
* @param {Find_Replace_Next_Result_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_next_result_aria_label = /** @type {((inputs?: Find_Replace_Next_Result_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Next_Result_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_next_result_aria_label(inputs)
	if (locale === "de") return de_find_replace_next_result_aria_label(inputs)
	if (locale === "it") return it_find_replace_next_result_aria_label(inputs)
	if (locale === "ru") return ru_find_replace_next_result_aria_label(inputs)
	if (locale === "es") return es_find_replace_next_result_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_next_result_aria_label(inputs)
	if (locale === "ja") return ja_find_replace_next_result_aria_label(inputs)
	if (locale === "hi") return hi_find_replace_next_result_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_next_result_aria_label(inputs)
	return en_find_replace_next_result_aria_label(inputs)
});